import React from "react";

interface AccordionPanelProps {
  content: React.ReactNode;
  isExpanded: boolean;
  id: string;
  ariaLabelledby: string;
  accordionPanelClassName?: string;
}

const AccordionPanel: React.FC<AccordionPanelProps> = ({
  content,
  isExpanded,
  id,
  ariaLabelledby,
  accordionPanelClassName = "",
}) => {
  return (
    <div
      id={id}
      className={`grid transition-all duration-300 ease-in-out
        border-b border-border-gray dark:border-border-gray-dk
        ${isExpanded ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}
        ${accordionPanelClassName}`}
      aria-hidden={!isExpanded}
      role="region"
      aria-labelledby={ariaLabelledby}
    >
      <div className="overflow-hidden">
        <div className="text-md text-verba-indigo dark:text-verba-indigo-dk">
          {content}
        </div>
      </div>
    </div>
  );
};

export default AccordionPanel;
